<template>
  <div class="ConsultLicenseViewContainer">
    <div class="wbg brd16 pd16" style="padding-bottom: 50px">
      <nut-row class="bothCenter">
        <nut-col :span="20" class="leftCenter">
          <span class="smallFont">{{ infos[typeId].title }}</span>
        </nut-col>
        <nut-col :span="4" class="rightCenter">
          <img src="https://cdn.waityou.online/a4b7eeb1-0977-e963-e8ac-2321c6cccf90.png" @click="downloadFile"
               style="width: 80%"/>
        </nut-col>
      </nut-row>
      <img v-for="(img,imgIndex) in infos[typeId].imgs" :key="imgIndex" :src="img" style="width: 100%"/>
    </div>
  </div>
  <nut-row class="wd100 wbg vpd16 bothCenter" style="position:fixed;bottom: 0">
    <nut-button class="jumpBtn" @click="gotoWeb">立即办理</nut-button>
  </nut-row>
</template>

<script>
import {Toast} from "@nutui/nutui";

export default {
  name: "ConsultLicenseView",
  data() {
    return {
      typeId: this.$route.params.typeId,
      infos: {
        1: {
          title: '公众聚集场所投入使用、营业前消防安全检查许可（宾馆、饭店）',
          file: 'https://cdn.waityou.online/7d2aebc4-b80c-0d45-798d-39d5a0eba6bb.doc',
          imgs: ['https://cdn.waityou.online/3567b6db-3125-dcdc-c2a0-b332989272ab.png', 'https://cdn.waityou.online/ff7718e4-09ea-289e-3a62-dde5ca1db8fb.png'],
          link: 'https://portal.zjzwfw.gov.cn/h5/portal/user?catalogId=cda2de3a-054f-4e30-a22b-90b913ed4cb5&name=公众聚集场所投入使用、营业前消防安全检查许可（宾馆、饭店）#/apps/matters/area'
        },
        2: {
          title: '公众聚集场所投入使用、营业前消防安全检查许可（公共娱乐场所）',
          file: 'https://cdn.waityou.online/d7cad179-9902-9177-083f-2f57c627f5c3.doc',
          imgs: ['https://cdn.waityou.online/3567b6db-3125-dcdc-c2a0-b332989272ab.png', 'https://cdn.waityou.online/ff7718e4-09ea-289e-3a62-dde5ca1db8fb.png'],
          link: 'https://portal.zjzwfw.gov.cn/h5/portal/user?catalogId=bb1981a4-aa76-48d5-9efc-149eb2fd49c7&name=公众聚集场所投入使用、营业前消防安全检查许可（公共娱乐场所）#/apps/matters/area'
        },
        3: {
          title: '公众聚集场所投入使用、营业前消防安全检查许可（体育场馆、会堂）',
          file: 'https://cdn.waityou.online/4d2fd61d-c1d8-4a8c-88a8-d7cf657d371b.doc',
          imgs: ['https://cdn.waityou.online/3567b6db-3125-dcdc-c2a0-b332989272ab.png', 'https://cdn.waityou.online/ff7718e4-09ea-289e-3a62-dde5ca1db8fb.png'],
          link: 'https://portal.zjzwfw.gov.cn/h5/portal/user?catalogId=9e8276c4-09cb-46c8-8217-75ab0c943086&name=公众聚集场所投入使用、营业前消防安全检查许可（体育场馆、会堂）#/apps/matters/area'
        },
        4: {
          title: '公众聚集场所投入使用、营业前消防安全检查许可（商场、集贸市场）',
          file: 'https://cdn.waityou.online/540589a8-f8b2-7198-d95a-ab612d4e9114.doc',
          imgs: ['https://cdn.waityou.online/3567b6db-3125-dcdc-c2a0-b332989272ab.png', 'https://cdn.waityou.online/ff7718e4-09ea-289e-3a62-dde5ca1db8fb.png'],
          link: 'https://portal.zjzwfw.gov.cn/h5/portal/user?catalogId=812f9e1e-1e90-41b0-bd79-f8b103281692&name=公众聚集场所投入使用、营业前消防安全检查许可（商场、集贸市场）#/apps/matters/area'
        },
        5: {
          title: '公众聚集场所投入使用、营业前消防安全检查许可（客运车站候车室、客运码头候船厅、民用机场航站楼）',
          file: 'https://cdn.waityou.online/3bca68f9-3e1e-44e8-21bb-ea7d84d2e5ff.doc',
          imgs: ['https://cdn.waityou.online/3567b6db-3125-dcdc-c2a0-b332989272ab.png', 'https://cdn.waityou.online/ff7718e4-09ea-289e-3a62-dde5ca1db8fb.png'],
          link: 'https://portal.zjzwfw.gov.cn/h5/portal/user?catalogId=e02229c4-5fa7-4830-a5aa-f5b3b6f4b2c9&name=公众聚集场所投入使用、营业前消防安全检查许可（客运车站候车室、客运码头候船厅、民用机场航站楼）#/apps/matters/area'
        },
        6: {
          title: '火灾事故认定复核',
          file: 'https://cdn.waityou.online/1adada62-9341-9516-851c-c835cdfbc1fd.doc',
          imgs: ['https://cdn.waityou.online/e79270ae-ce56-c29d-1236-bdb9c789486b.jpeg'],
          link: 'https://portal.zjzwfw.gov.cn/h5/portal/user?catalogId=8609c210-7a11-11e4-adde-2c44fd81deba&name=火灾事故认定复核#/apps/matters/area'
        },
        7: {
          title: '火灾事故原因认定',
          file: 'https://cdn.waityou.online/4237f663-e7a2-df87-3cd4-8284709f6c6a.doc',
          imgs: ['https://cdn.waityou.online/05d262c4-a78c-9595-0765-dc181533e7e5.jpeg'],
          link: 'https://www.zjzwfw.gov.cn/zjservice/item/detail/index.do?localInnerCode=f458511a-9821-416a-96fa-c5795fa88607'
        },
        8: {
          title: '专职消防队验收',
          file: 'https://cdn.waityou.online/3f46148b-bc68-17da-9732-727cd262bf69.doc',
          imgs: ['https://cdn.waityou.online/a136f0e8-09a4-9380-22dc-69e15aef7c5f.jpeg'],
          link: 'https://www.zjzwfw.gov.cn/zjservice/item/detail/index.do?localInnerCode=dc12c4c6-bb6b-487d-a1dd-0d4d11cf078b'
        },
        9: {
          title: '恢复使用、生产、经营申请',
          file: 'https://cdn.waityou.online/939484b2-43e8-4971-f492-e2b80a8e8ae7.doc',
          imgs: ['https://cdn.waityou.online/f359b657-9f9a-6652-4c40-c0ea881bb3d8.png'],
          link: 'https://portal.zjzwfw.gov.cn/h5/portal/user?catalogId=71ea951c-6c6d-4a21-b095-44250808ddd6&name=恢复使用、生产、经营申请#/apps/matters/area'
        },
        10: {
          title: '临时查封解除申请',
          file: 'https://cdn.waityou.online/3a4f44c1-4218-23e9-df7f-8c6b363f5c27.doc',
          imgs: ['https://cdn.waityou.online/29baebc9-0321-e11b-98ca-a3e11970d5f3.png'],
          link: 'https://portal.zjzwfw.gov.cn/h5/portal/user?catalogId=5f2a5ca9-8920-4fc8-835d-bab1d6ef9905&name=临时查封解除申请#/apps/matters/area'
        },
      }
    }
  },
  methods: {
    downloadFile() {
      Toast.loading('请稍等...')
      window.open(this.infos[this.typeId].file, '_blank')
    },
    gotoWeb() {
      Toast.loading('请稍等...')
      // eslint-disable-next-line no-undef
      ZWJSBridge.openLink({
        url: this.infos[this.typeId].link
      }).then((result) => {
        console.log('前往新页面', this.infos[this.typeId].link, result);
      }).catch((error) => {
        console.log('前往新页面失败', this.infos[this.typeId].link, error);
      });
      // window.location.href = this.infos[this.typeId].link
    }
  },

  mounted() {
  }
}
</script>

<style lang="scss" scoped>
.jumpBtn {
  height: 44px;
  background: #2F438C;
  border-radius: 12px;
  color: white;
  border: none;
  width: calc(100vw - 32px);
}

.ConsultLicenseViewContainer {
  display: flex;
  flex-direction: column;
  background-color: #F4F6F9;
  padding: 16px 16px 100px 16px;
  min-height: calc(100vh - 32px);
}
</style>